import { CheckCircle2, Circle, Loader2 } from 'lucide-react';
import type { PlatformActivationStep } from '@/types/platform';

function StepIcon({ status }: { status: PlatformActivationStep['status'] }) {
  if (status === 'completed') return <CheckCircle2 className="h-5 w-5 text-status-allow shrink-0" />;
  if (status === 'in_progress') return <Loader2 className="h-5 w-5 text-primary shrink-0" />;
  return <Circle className="h-5 w-5 text-muted-foreground shrink-0" />;
}

interface ActivationChecklistProps {
  steps: PlatformActivationStep[];
  completed: number;
  total: number;
}

/** Read-only activation checklist for the admin org-detail view (prop-driven). */
export function ActivationChecklist({ steps, completed, total }: ActivationChecklistProps) {
  const pct = total > 0 ? Math.round((completed / total) * 100) : 0;
  return (
    <div className="rounded-lg border bg-card p-4">
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-sm font-semibold">Activation</h3>
        <span className="text-xs text-muted-foreground">
          {completed} of {total} steps
        </span>
      </div>
      <div className="h-1.5 w-full rounded-full bg-muted overflow-hidden mb-4">
        <div className="h-full bg-primary rounded-full transition-all" style={{ width: `${pct}%` }} />
      </div>
      <ul className="space-y-2">
        {steps.map((step) => (
          <li key={step.id} className="flex items-center gap-3 text-sm">
            <StepIcon status={step.status} />
            <span
              className={step.status === 'completed' ? 'text-foreground' : 'text-muted-foreground'}
            >
              {step.label}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
